import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON004_Request,
  IAPI_CON004_Response,
} from "../../../type/apiType";

// 「俸給の調整額」対象手当一覧参照API
// API仕様書_契約者
const httpAPI_CON004 = async (
  param: IAPI_CON004_Request
): Promise<IAPI_CON004_Response> => {
  let res = await http.post(ApiUrl.API_CON004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON004 };
